import React from "react";
import PropTypes from "prop-types";
import Collapsible from "react-collapsible";
import SourceItem from "./SourceItem";

const TiCloudSources = ({ data }) => {
  const sources = data?.named_group || data?.grouped;

  return (
    <div>
      {sources ? (
        Object.entries(sources).map(([groupName, group], groupIdx) => (
          <Collapsible
            key={groupName}
            trigger={
              <div className="react-collapsible__heading-container">
                <span className="react-collapsible__heading-title">
                  {groupName}
                </span>
              </div>
            }
            open={groupIdx === 0}
            classParentString="react-collapsible"
            transitionTime={200}
            easing="ease-out"
          >
            <div className="react-collapsible__content">
              {group.map((groupItem, groupItemIdx) => (
                <SourceItem data={groupItem} key={groupItemIdx} />
              ))}
            </div>
          </Collapsible>
        ))
      ) : (
        <p>
          <b>No Sources to Display</b>
        </p>
      )}
    </div>
  );
};

TiCloudSources.propTypes = {
  data: PropTypes.oneOfType([PropTypes.shape(), PropTypes.array])
};

export default TiCloudSources;
